__turbopack_context__.v({
  "label-component-slot": "UsageInputLabelComponent-module-scss-module__UkUdaq__label-component-slot",
});
